import { MutationTree } from 'vuex';
import { EmpathizeState } from '../../models';
import { ClearEmpathizeStateMutation } from './mutations/clear-empathize-state.mutation';
import { SaveEmpathizeResponseMutation } from './mutations/save-empathize-response.mutation';
import { SetLoadingMutation } from './mutations/set-loading.mutation';
import { SetSelectedIndexMutation } from './mutations/set-selected-index.mutation';

export const EMPATHIZE_MUTATIONS: MutationTree<EmpathizeState> = {
  ...new ClearEmpathizeStateMutation().mutations,
  ...new SaveEmpathizeResponseMutation().mutations,
  ...new SetLoadingMutation().mutations,
  ...new SetSelectedIndexMutation().mutations
};
